/* section-testimonials.js — extracted from sections/testimonials.liquid */
  function initTestimonialsSection() {
    function initTestimonialsSlider(section) {
      const track = section.querySelector('.testimonials__track');
      const cards = section.querySelectorAll('.testimonial-card');
      if (!track || cards.length < 2) return;

      const prevBtn = section.querySelector('[data-t-prev]');
      const nextBtn = section.querySelector('[data-t-next]');
      const dotsContainer = section.querySelector('.slider-dots');
      let currentIndex = 0;

      function isMobileLayout() {
        return window.matchMedia('(max-width: 639px)').matches;
      }

      function buildDots() {
        if (!dotsContainer || dotsContainer.childElementCount > 0) return;
        cards.forEach(function (_, i) {
          const dot = document.createElement('button');
          dot.className = 'slider-dot';
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.addEventListener('click', function () { goTo(i); });
          dotsContainer.appendChild(dot);
        });
      }

      function goTo(index) {
        currentIndex = Math.max(0, Math.min(index, cards.length - 1));
        cards[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        update();
      }

      function update() {
        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex === cards.length - 1;
        const dots = dotsContainer ? dotsContainer.querySelectorAll('.slider-dot') : [];
        dots.forEach(function (d, i) { d.classList.toggle('slider-dot--active', i === currentIndex); });
      }

      function init() {
        if (!isMobileLayout()) return;
        track.classList.add('is-slider');
        buildDots();
        update();
      }

      prevBtn && prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
      nextBtn && nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

      const mq = window.matchMedia('(max-width: 639px)');
      mq.addEventListener('change', function () {
        if (!mq.matches) {
          track.classList.remove('is-slider');
        } else {
          track.classList.add('is-slider');
          buildDots();
          update();
        }
      });

      init();
    }

    document.querySelectorAll('.testimonials').forEach(initTestimonialsSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialsSection);
  } else {
    initTestimonialsSection();
  }

  document.addEventListener('shopify:section:load', function(ev) {
    initTestimonialsSection();
  });
